<div class="confirm-payment-container d-flex flex-column gap-4">
  <button type="button" class="btn btn-primary home-btn" (click)="onClick()">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>

  <app-error-banner
    *ngIf="pacErrorMessage"
    [message]="pacErrorMessage">
  </app-error-banner>

  <div *ngIf="!pacErrorMessage" class="payment-container card p-3 gap-4">
    <span class="title">
      {{ isSinglePayment ? 'Confirm Payment Details' : 'Select one or more installments to make payment' }}
    </span>

    <div class="p-3" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
      <strong>General Information and Instructions:</strong>
      <ul class="mt-2 mb-0 ps-3">
        <li>Confirm payment details to proceed with payment </li>
        <li *ngIf="!isSinglePayment">
          <strong>Instalment Payment Rules & Selection Criteria:</strong>
          <ul class="mt-2 ps-3">
            <li><strong>Default Selection:</strong> Only the first instalment is enabled by default; all others are initially disabled.</li>
            <li><strong>Multiple Instalments Allowed:</strong> You can select one or more instalments for payment.</li>
            <li><strong>Sequential Selection is Mandatory:</strong> Instalments must be selected in order without skipping.</li>
            <li><strong>Deselecting Instalments</strong>: Only the last selected instalment can be deselected.</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="payment-container-info d-flex flex-column gap-5">
      <div class="payer-information d-flex flex-column">
        <div class="sub-title mb-2">Payer Information</div>

        <div class="info d-flex align-items-center">
          <span class="meta-key">Payer Name:</span>
          <span class="meta-value light">{{ payerData?.payerName }}</span>
        </div>

        <div class="info d-flex align-items-center">
          <span class="meta-key">Payment Reference:</span>
          <span class="meta-value">{{ pacNumber }}</span>
        </div>

        <!-- One-time payment only -->
        @if (isSinglePayment && singlePayment) {
          <div class="info d-flex align-items-center">
            <span class="meta-key">Due Date:</span>
            <span class="meta-value">{{ singlePayment.paymentDueDate }}</span>
          </div>
          <div class="info d-flex align-items-center  mb-4">
            <span class="meta-key">Outstanding Amount:</span>
            <span class="meta-value bold">
              {{ showAmountFormatted(singlePayment.paymentDueAmount) }}
            </span>
          </div>
        }

        <div class="p-3 mb-4" style="background-color: #f8f9fa; border-left: 4px solid var(--primary); border-radius: 4px;">
          <div class="mt-0 mb-0">
            Enter at least one contact details below to proceed.
          </div>
        </div>


        <!-- Contact Info -->
        <div class="info d-flex align-items-center input-fields">
          <span class="meta-key">E-mail Address:</span>
          <div class="input-wrapper">
            <label for="emailId" class="visually-hidden">Email Id</label>
            <input
              id="emailId"
              class="form-control vkeyboard"
              [ngClass]="{ 'is-invalid': emailInput.invalid && emailInput.touched }"
              type="email"
              name="email"
              placeholder="eg: john@gmail.com"
              [(ngModel)]="emailId"
              #emailInput="ngModel"
              email
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              autocomplete="off"
            />
            <div *ngIf="(emailInput.dirty || emailInput.touched) && emailInput.invalid" class="text-danger mt-1">
              <small *ngIf="emailInput.errors?.['email']"><span class="error-icon">–</span>Please enter a valid email address to receive receipt for your payment.</small>
            </div>
          </div>
        </div>

        <div class="info d-flex align-items-center input-fields mt-2">
          <span class="meta-key">Contact Number:</span>
          <div class="input-wrapper">
            <label for="contactNumber" class="visually-hidden">Contact Number</label>
            <input
              id="contactNumber"
              class="form-control vkeyboard"
              [ngClass]="{ 'is-invalid': contact.invalid && contact.touched }"
              type="text"
              name="contactNumber"
              placeholder="Enter Contact Number"
              [(ngModel)]="contactNumber"
              pattern="^[689][0-9]{7}$"
              maxlength="8"
              minlength="8"
              #contact="ngModel"
              autocomplete="off"
              (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? null : $event.preventDefault()"
            />
            <div *ngIf="contact.invalid &&  (contact.dirty || contact.touched) " class="text-danger mt-1">
              <span class="error-icon">–</span>Please enter a Singapore registered phone number.
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-error-banner *ngIf="errorMessage" [message]="errorMessage"></app-error-banner>

    <!-- Installment payment table -->
    <ng-container *ngIf="!isSinglePayment">
      <div class="payment-details gap-4 d-flex flex-column mt-2">
        <div class="sub-title">Payment Details</div>

        <!-- Desktop Table View -->
        <div class="table-responsive d-none d-sm-block">
          <table class="table" aria-label="Payment Details">
            <thead>
            <tr>
              <th>Instalment Reference</th>
              <th>Due Date</th>
              <th>Due Amount</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let line of paymentLineItems; let i = index">
              <td>
                <input
                  class="form-check-input"
                  type="checkbox"
                  [id]="'CheckboxDefault' + i"
                  name="CheckboxDefault"
                  [checked]="checkboxStates[i]?.checked"
                  [disabled]="!checkboxStates[i]?.enabled"
                  (change)="toggleSelection(i)"
                />
                <label [for]="'CheckboxDefault' + i">{{ line.instalmentNumber }}</label>
              </td>
              <td>{{ line.paymentDueDate }}</td>
              <td>${{ line.paymentDueAmount.toFixed(2) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile View -->
        <div class="table-mobile-container d-block d-sm-none">
          <div
            class="row-mobile d-flex align-items-center"
            *ngFor="let line of paymentLineItems; let i = index"
          >
            <div class="d-flex gap-2 align-items-center">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'mobileCheck' + i"
                [checked]="checkboxStates[i]?.checked"
                [disabled]="!checkboxStates[i]?.enabled"
                (change)="toggleSelection(i)"
              />
              <label [for]="'mobileCheck' + i">
                <div class="d-flex flex-column">
                  <span class="reference">{{ line.instalmentNumber }}</span>
                  <span class="due-by">Due by {{ line.paymentDueDate }}</span>
                </div>
              </label>
            </div>
            <span class="amount">${{ line.paymentDueAmount.toFixed(2) }}</span>
          </div>
        </div>

        <span class="d-flex align-self-end to-pay">
          To Pay ($): {{ getTotalAmount().toFixed(2) }}
        </span>
      </div>
    </ng-container>

    <!-- Action Buttons -->
    <div class="button-container d-flex gap-3 align-self-end">
      <button type="button" class="btn btn-outline" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary home-btn d-flex align-self-end" (click)="onConfirm()" [disabled]="isConfirmDisabled(emailInput, contact)">Confirm</button>
    </div>
  </div>
</div>

<app-virtual-keyboard></app-virtual-keyboard>
